import React, { memo } from 'react';
import moment from 'moment';
import { StoryblokNode } from '../../interfaces/StoryblokNode.interface';
import { StoryblokArticleAuthor } from '../../interfaces/StoryblokArticleAuthor.interface';
import Image from '../Image/Image';
import CustomLink from '../CustomLink/CustomLink';
import SbImage from '../SbImage/SbImage';

interface ArticleHeroAuthorProps {
  author: StoryblokNode<StoryblokArticleAuthor>;
  publishedDateOverride?: string;
  updatedDateOverride?: string;
  publishedAt: string;
  updatedDate?: string;
}

const ArticleHeroAuthor: React.FC<ArticleHeroAuthorProps> = ({
  author,
  publishedDateOverride = undefined,
  updatedDateOverride = undefined,
  publishedAt,
  updatedDate,
}) => {
  const { avatar, full_name, role, bio, linkedin_url } = author?.content;

  return (
    <li className="group flex items-center justify-start gap-x-4">
      <div className="w-14 h-14 rounded-full overflow-hidden bg-text/body-tint">
        {avatar?.filename && (
          <SbImage asset={avatar} options={{ sizes: { base: 120 } }} />
        )}
      </div>
      <div>
        {full_name && (
          <CustomLink
            url={linkedin_url}
            label={full_name}
            className="text-text/body font-bold group-hover:underline"
            target="_blank"
          >
            {full_name}
          </CustomLink>
        )}
        {role && <p className="text-text/body-tint font-medium">{role}</p>}
        {bio && <p className="text-text/body-tint font-normal">{bio}</p>}
        {(publishedDateOverride || publishedAt) && (
          <p className="text-text/body-tint">
            Published{' '}
            {moment(publishedDateOverride || publishedAt).format(
              'MMMM Do YYYY'
            )}
          </p>
        )}
        {(updatedDateOverride || updatedDate) && (
          <p className="text-text/body-tint">
            Updated on{' '}
            {moment(updatedDateOverride || updatedDate).format('MMMM Do YYYY')}
          </p>
        )}
      </div>
    </li>
  );
};

export default memo(ArticleHeroAuthor);
